/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUploadSanctionListInput = {
    clientMutationId?: string | null;
    identifier: string;
};
export type SanctionListUploadMutationVariables = {
    input: infoUploadSanctionListInput;
};
export type SanctionListUploadMutationResponse = {
    readonly infoUploadSanctionList: {
        readonly clientMutationId: string | null;
    } | null;
};
export type SanctionListUploadMutation = {
    readonly response: SanctionListUploadMutationResponse;
    readonly variables: SanctionListUploadMutationVariables;
};



/*
mutation SanctionListUploadMutation(
  $input: infoUploadSanctionListInput!
) {
  infoUploadSanctionList(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUploadSanctionListPayload",
    "kind": "LinkedField",
    "name": "infoUploadSanctionList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SanctionListUploadMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SanctionListUploadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f5bf908808f0a4d6db01f78bf2ed25b7",
    "id": null,
    "metadata": {},
    "name": "SanctionListUploadMutation",
    "operationKind": "mutation",
    "text": "mutation SanctionListUploadMutation(\n  $input: infoUploadSanctionListInput!\n) {\n  infoUploadSanctionList(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b18a9234083fa5b4d89ae0e0776fe347';
export default node;
